<script setup lang="ts">
import type { ProductSchema } from '@laam/cms-shared';
import { productInjectKey } from '~/types/Product';

const productData = inject<ProductSchema>(productInjectKey);
const svgUrl = computed(() => {
	return SVG_MAP[`${productData?.node_l1}-${productData?.node_l4}`] || '';
});
</script>

<template>
	<NuxtImg v-if="svgUrl" :src="svgUrl" class="lg:h-[600px]" />
</template>
